import { Overlay, showDialog } from "vant"
import { computed, createApp, defineComponent, ref } from "vue"
import styles from "./index.module.less"

const PreviewVNode = defineComponent({
  name: "PromptVNode",
  inheritAttrs: false,
  props: {
    index: { type: Number, default: 0 },
    paths: { type: Array, default: () => [] },
    maxZoom: { type: Number, default: 10 },
    minZoom: { type: Number, default: 0.2 },
    zoomStep: { type: Number, default: 0.2 },
    rotateStep: { type: Number, default: 90 },
    canDownload: { type: Boolean, default: false }
  },
  emits: ["close"],
  setup(props, { emit }) {
    const visible = ref(true)
    const getContainer = () => window.parent.document.body

    const index = ref(props.index)
    const showImg = computed(() => {
      return props.paths[index.value]
    })

    const stopPropagation = (e) => {
      e.stopPropagation()
    }

    const videoRef = ref()
    const handleVideoError = () => {
      showDialog({ message: "抱歉，您的浏览器不支持播放该视频" })
      visible.value = false
    }

    return () => (
      <Overlay show={visible.value} onClick={() => (visible.value = false)}>
        {visible.value && (
          <div class={styles.videoModal}>
            <video
              ref={videoRef}
              style="width: 100%"
              controls
              autoplay
              webkit-playsinline
              playsinline
              x5-video-player-type="h5"
              onClick={stopPropagation}
              onError={handleVideoError}
            >
              <source src={showImg.value.path} />
            </video>
          </div>
        )}
      </Overlay>
    )
  }
})

const body = document.getElementsByTagName("body")[0]
const div = document.createElement("div")
body.appendChild(div)

export const usePreviewVideo = (props) => {
  const app = createApp(PreviewVNode, {
    ...props,
    onClose() {
      app.unmount()
    }
  })
  app.mount(div)
}
